import { HTTP } from '@/api/common'

const state = {
  userSecurities: {},
  userSecuritiesTableLoading: false,
  userSecuritiesSnapshots: [],
  user_securities_snapshot_chart_loading: false,
  userSecuritiesSnapshotsDJI: [],
  user_securities_snapshot_dji_chart_loading: false,
  candlestick_data: [],
  candlestick_data_loading: false,
  purchased_rows:[],
  purchased_rows_loading: false,
  current_symbol:{},
  current_symbol_loading:false,
  securitiesSectors:[],
}

const getters = {
  userSecurities: state => state.userSecurities,
  userSecuritiesTableLoading: state => state.userSecuritiesTableLoading,
  userSecuritiesSnapshots: state => state.userSecuritiesSnapshots,
  user_securities_snapshot_chart_loading: state => state.user_securities_snapshot_chart_loading,
  userSecuritiesSnapshotsDJI: state => state.userSecuritiesSnapshotsDJI,
  user_securities_snapshot_dji_chart_loading: state => state.user_securities_snapshot_dji_chart_loading,
  candlestick_data: state => state.candlestick_data,
  candlestick_data_loading: state => state.candlestick_data_loading,
  purchased_rows: state => state.purchased_rows,
  purchased_rows_loading: state => state.purchased_rows_loading,
  current_symbol: state => state.current_symbol,
  current_symbol_loading: state => state.current_symbol_loading,
  securities_sectors: state => {
    let sectors = {}
    Object.values(state.securitiesSectors).forEach(v => {
      sectors[v['name'].toLowerCase()] = v['color']
    })
    return sectors
  },
  sector_colors: (state) => (sectors_list) => {
    let sectors = {}
    Object.values(state.securitiesSectors).forEach(v => {
      sectors[v['name'].toLowerCase()] = v['color']
    })
    let colors = []
    for (const s of sectors_list){
      if (sectors[s.toLocaleLowerCase()]) {
        colors.push(sectors[s.toLocaleLowerCase()])
      }
    }
    return colors
  }
}

const mutations = {
  SET_USER_SECURITIES (state, securities) {
    state.userSecurities.symbols = securities.symbols
    state.userSecurities.updated = securities.updated
    state.userSecurities.symbols_list = securities.symbols.map(item => {
      return item.symbol.symbol
    })
  },
  SET_USER_SECURITIES_LOADING (state, loading) {
    state.userSecuritiesTableLoading = loading
  },
  SET_USER_SECURITIES_SNAPSHOTS (state, snapshots) {
    state.userSecuritiesSnapshots = snapshots
  },
  SET_USER_SECURITIES_SNAPSHOTS_LOADING (state, loading) {
    state.user_securities_snapshot_chart_loading = loading
  },
  SET_USER_SECURITIES_SNAPSHOTS_DJI (state, snapshots) {
    state.userSecuritiesSnapshotsDJI = snapshots
  },
  SET_USER_SECURITIES_SNAPSHOTS_DJI_LOADING (state, loading) {
    state.user_securities_snapshot_dji_chart_loading = loading
  },
  SET_CANDLESTICK_DATA (state, candlestick_data) {
    state.candlestick_data = candlestick_data
  },
  SET_CANDLESTICK_LOADING (state, loading) {
    state.candlestick_data_loading = loading
  },
  SET_USER_PURCHASED_ROWS_LOADING (state, loading) {
    state.purchased_rows_loading = loading
  },
  SET_USER_PURCHASED_ROWS (state, items) {
    state.purchased_rows = items
  },
  SET_CURRENT_SYMBOL (state, current_symbol) {
    state.current_symbol = current_symbol
  },
  SET_CURRENT_SYMBOL_LOADING (state, loading) {
    state.current_symbol_loading = loading
  },
  SET_USER_SECURITIES_SECTORS (state, sectors) {
    state.securitiesSectors = sectors
  }
}

const actions = {
  getCurrentSymbol ({commit}, symbol_id) {
    commit('SET_CURRENT_SYMBOL_LOADING', true)
    return HTTP.get('/securities/client/symbol/'+symbol_id+'/')
      .then(r => r.data)
      .then(current_symbol => {
        if (current_symbol.symbolhistory.length > 0){
          let symbolhistory = current_symbol.symbolhistory
          let values = []
          for (let s in symbolhistory) {
            values.push({'x':symbolhistory[s].f_date+' GMT', 'y':symbolhistory[s].close})
          }
          current_symbol.symbolhistory = [{
            name:'Test',
            data: values
          }]
        } else {
          current_symbol.symbolhistory = ''
        }

        console.log(current_symbol)
        commit('SET_CURRENT_SYMBOL', current_symbol)
        commit('SET_CURRENT_SYMBOL_LOADING', false)
        return current_symbol
      })

  },
  getSecuritiesSectors ({commit}) {
    return HTTP.get('/securities/sectors/')
    .then(r => r.data)
    .then(securities => {
      commit('SET_USER_SECURITIES_SECTORS', securities)
    })
  },
  getUserSecurities ({commit}) {
    commit('SET_USER_SECURITIES_LOADING', true)
    return HTTP.get('/securities/client/')
      .then(r => r.data)
      .then(securities => {
        commit('SET_USER_SECURITIES', securities)
        commit('SET_USER_SECURITIES_LOADING', false)
        return securities
      })
  },
  getPurchasedRows ({commit}){
    commit('SET_USER_PURCHASED_ROWS_LOADING', true)
    HTTP.get('/securities/client/purchased_rows/')
      .then(r => r.data)
      .then(securities => {
        commit('SET_USER_PURCHASED_ROWS', securities)
        commit('SET_USER_PURCHASED_ROWS_LOADING', false)
      })
  },
  getUserSecuritiesSnapshots ({commit}) {
    commit('SET_USER_SECURITIES_SNAPSHOTS_LOADING', true)
    commit('SET_USER_SECURITIES_SNAPSHOTS_DJI_LOADING', true)
    HTTP.get('/securities/client/snapshots/')
      .then(r => r.data)
      .then(snapshots => {
        HTTP.get('https://www.alphavantage.co/query', {
          params:{
            function:'TIME_SERIES_DAILY_ADJUSTED',
            symbol:'DJI',
            outputsize: 'compact',
            apikey: 'WS94IXXJSMN06SBL'
          }
        }).then(r => {
          let dji_data = r.data['Time Series (Daily)']
          let chart_data = []
          let dji_chart_data = []
          let start_date = Date.parse(snapshots[0].f_date)
          let chart_start_date = new Date()
          chart_start_date.setTime(start_date)
          chart_start_date.setDate(chart_start_date.getDate()-1)
          for (let i in snapshots) {
            chart_data.push({
              x:snapshots[i].f_date + ' GMT',
              y:snapshots[i].sum,
              test:dji_data[snapshots[i].date['close']]
            })
            // date_list.push(snapshots[i].f_date)
            if (dji_data[snapshots[i].date]){
              dji_chart_data.push({
                x:snapshots[i].f_date + ' GMT',
                y:parseFloat(dji_data[snapshots[i].date]['4. close'])
              })
            } else{
              dji_chart_data.push({
                x:snapshots[i].f_date + ' GMT',
                y:null
              })
            }


            // console.log(snapshots[i])
            // charts['snapshots']['data'].push(snapshots[i].sum)
          }
          let snapshots_chart = [{
            name:'Стоимость портфеля',
            data:chart_data,
            // start_date:chart_start_date
          }]
          let dji_chart = [{
            name:'Индекс DJI',
            data:dji_chart_data
          }]
          console.log(dji_chart)
          console.log(snapshots_chart)
          commit('SET_USER_SECURITIES_SNAPSHOTS', snapshots_chart)
          commit('SET_USER_SECURITIES_SNAPSHOTS_DJI', dji_chart)
          commit('SET_USER_SECURITIES_SNAPSHOTS_LOADING', false)
          commit('SET_USER_SECURITIES_SNAPSHOTS_DJI_LOADING', false)
        })

      })
  },
  getSymbolStockData ({commit}, payload){
    commit('SET_CANDLESTICK_LOADING', true)
    console.log('xxx ' + payload)
    return HTTP.get('/securities/'+payload.symbol_id+'/history/daily/', {
      params: payload
    })
      .then(r => r.data)
      .then(response_data => {
        console.log(data)
        let data = response_data.data
        // series.push({
        //   data:[]
        // })
        let chart_data = []
        let min_value = data[0].low
        let max_value = data[0].high
        for (let i in data) {
          // console.log(Date.parse(data[i].date))
          data[i].high > max_value ? max_value = data[i].high : max_value
          data[i].low < min_value ? min_value = data[i].low: min_value
          chart_data.push({
            x:new Date(Date.parse(data[i].date)),
            y:[data[i].open, data[i].high, data[i].low, data[i].close]
          })
        }
        min_value = parseFloat(min_value - min_value*0.07)
        max_value = parseFloat(max_value + max_value*0.07)
        let response = {
          series: [{
            data: chart_data
          }],
          min_value,
          max_value,
          min_date: response_data.min_date,
          max_date: response_data.max_date,
          to_date: response_data.to_date,
          from_date: response_data.from_date,
          allowed_dates: response_data.allowed_dates
        }

        commit('SET_CANDLESTICK_DATA', response)

      })
  }
}

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}
